import dayjs, { toLocal } from "./dayjs";

export const capitalizedFirst = (value) => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const formatDate = (date, format = "DD MMM, YYYY, hh:mm A") => {
  // Store-timezone aware (falls back to device-local until a store timezone is set).
  return date ? toLocal(date).format(format) : "-";
};

export const splitName = (fullName) => {
  if (!fullName) return { firstName: "", lastName: "" };

  const parts = fullName.trim().split(/\s+/);
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || "";

  return { firstName, lastName };
};

export const formatAddress = (data) => {
  if (!data) return "-";
  const { address1, address2, city, state, zip } = data;

  const addressLine = [
    address1,
    address2,
    [city, state, zip].filter(Boolean).join(", "),
  ];
  return addressLine.filter(Boolean).join("\n");
};

export const getTimeDifference = (date) => {
  const now = new Date();
  const pastDate = new Date(date);

  const difference = Math.abs(now - pastDate) / 1000;

  if (difference < 60) return "less than a minute ago";

  return dayjs(pastDate).fromNow();
};

export const formatCurrency = (value) => {
  return value.toLocaleString("en-US", { maximumFractionDigits: 3 });
};

// Default 3 decimals to match the backend DECIMAL(18,3) money columns and
// 3-dp currencies (KWD/BHD/OMR). Pass fixedPlace explicitly for other cases.
export const formatDecimal = (val, localize = false, fixedPlace = 3) => {
  const numericValue = parseFloat(val);
  if (isNaN(numericValue)) return localize ? (0).toFixed(fixedPlace) : 0;

  const fixedVal = parseFloat(numericValue.toFixed(fixedPlace));

  if (localize)
    return parseFloat(fixedVal).toLocaleString("en-US", {
      minimumFractionDigits: fixedPlace,
      maximumFractionDigits: fixedPlace,
    });

  return fixedVal;
};
